export default __webpack_public_path__ + "static/media/description-services.74f4bf73.jpeg";